var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[(_vm.complete)?_c('img',{staticClass:"badge-light",attrs:{"src":_vm.light}}):_vm._e(),(_vm.complete)?_c('img',{staticClass:"badge-icon",attrs:{"src":_vm.completeBadge}}):_c('img',{staticClass:"badge-icon",attrs:{"src":_vm.uncompleteBadge}})])
}
var staticRenderFns = []

export { render, staticRenderFns }